import { Question } from './question.js';
import { FACE_5_EMOJIS } from '../icons/emoji-data.js';

export class NPSQuestion extends Question {
    renderContent() {
        const isEmojiScale = this.question.colorScale === 'new5faces';
        let temArray = isEmojiScale ? [1, 2, 3, 4, 5] : Array.from({ length: 11 }, (_, i) => i);
        let ratingAnswer = null;

        let ratingBlock = document.createElement('div');
        ratingBlock.style.marginTop = '16px';
        ratingBlock.classList.add('ph-rating--small');
        ratingBlock.id = 'answerOptionsElement' + this.question.id;

        let ratingElement = document.createElement('div');
        ratingElement.classList.add('ph-rating__elements');
        ratingElement.style.gap = isEmojiScale ? '16px' : '4px';
        ratingElement.style.flexDirection = 'row';
        if (isEmojiScale) {
            ratingElement.style.justifyContent = 'space-between';
            ratingElement.style.width = '100%';
            ratingElement.style.padding = '8px 24px';
        }
        ratingElement.setAttribute('role', 'group');
        ratingElement.setAttribute('aria-labelledby', 'ph-title-' + this.question.id);
        ratingBlock.appendChild(ratingElement);

        let gradienColors = [
            '#AF2D4C',
            '#BC4B4D',
            '#C6624E',
            '#D0784F',
            '#D78345',
            '#E4A551',
            '#EEBC53',
            '#F7CF53',
            '#E2DF52',
            '#A2DC4B',
            '#3FD742'
        ]

        let trafficLightColors = [
            '#AF2D4C', 
            '#AF2D4C', 
            '#AF2D4C', 
            '#AF2D4C', 
            '#AF2D4C', 
            '#AF2D4C', 
            '#AF2D4C', 
            '#FFE154',
            '#FFE154', 
            '#3FD742',
            '#3FD742'
        ];

        let colorfulColors = [
            '#F7EAED',
            '#F7EAED',
            '#F7EAED',
            '#F7EAED',
            '#F7EAED',
            '#F7EAED',
            '#F7EAED',
            '#FFFAE2',
            '#FFFAE2',
            '#EAFFE3',
            '#EAFFE3'
        ]

        let emoji5Faces = null;
        if (isEmojiScale) {
            emoji5Faces = FACE_5_EMOJIS;
        }

        temArray.forEach((index) => {
            let ratingButton = document.createElement('button');
            if (isEmojiScale) {
                ratingButton.classList.add('ph-emoji__item');
                ratingButton.style.border = '2px solid transparent';
                ratingButton.style.background = 'transparent';
                ratingButton.style.padding = '0';
                ratingButton.style.cursor = 'pointer';
                ratingButton.style.display = 'flex';
                ratingButton.style.justifyContent = 'center';
                ratingButton.style.alignItems = 'center';
                ratingButton.style.color = this.style.elementColor
                ratingButton.innerHTML = emoji5Faces[index - 1];
            } else {
                ratingButton.classList.add('ph-rating__btn--full');
                ratingButton.style.border = 'none';
                switch (this.question.colorScale) {
                    case 'hcGradient':
                        ratingButton.style.backgroundColor = gradienColors[index];
                        ratingButton.style.color = index < 5 ? 'white' : 'black';
                        break;
                    case 'hcTrafficLight':
                        ratingButton.style.backgroundColor = trafficLightColors[index];
                        ratingButton.style.color = index < 7 ? 'white' : 'black';
                        break;
                    case 'colorful':
                        ratingButton.style.backgroundColor = colorfulColors[index];
                        ratingButton.style.color = '#AF2D4C';
                        break;
                    default:
                        ratingButton.style.backgroundColor = '#F0F0F1';
                        ratingButton.style.color = this.style.elementColor || '#AF2D4C';
                }
                ratingButton.textContent = index;
            }
            
            ratingButton.id = 'nps' + this.question.id + index;
            ratingButton.value = Number(index);
            ratingButton.setAttribute('aria-label', `Score ${index}`);
            ratingButton.setAttribute('aria-pressed', 'false');
            ratingElement.appendChild(ratingButton);

            ratingButton.addEventListener('click', () => {
                let numberButtons = this.shadowRoot.querySelectorAll(`button[id^="nps${this.question.id}"]`);
                const isSelected = ratingButton.getAttribute('aria-pressed') === 'true';

                numberButtons.forEach((btn) => {
                    if (isEmojiScale) {
                        btn.style.borderColor = 'transparent';
                    } else {
                        btn.style.border = '2px solid #F0F0F1';
                    }
                    btn.setAttribute('aria-pressed', 'false');
                });

                if (isSelected) {
                    ratingAnswer = null;
                    this.ctx.updateAnswers(this.question, ratingAnswer);
                } else {
                    ratingButton.style.borderColor = this.style.elementColor || '#AF2D4C';
                    ratingButton.setAttribute('aria-pressed', 'true');
                    ratingAnswer = Number(ratingButton.value);
                    setTimeout(() => {
                        this.ctx.goNext(this.question, ratingAnswer);
                    }, 250);
                }
            });
        });

        let textBlock = document.createElement('div');
        textBlock.classList.add('ph-rating__context');

        let lowRatingTextElement = document.createElement('div');
        lowRatingTextElement.classList.add('ph-nps__label');
        lowRatingTextElement.textContent = this.question.ratingMiniText.text;
        lowRatingTextElement.style.textAlign = 'left';
        textBlock.appendChild(lowRatingTextElement);

        let longRatingTextElement = document.createElement('div');
        longRatingTextElement.classList.add('ph-nps__label');
        longRatingTextElement.textContent = this.question.ratingMaxText.text;
        longRatingTextElement.style.textAlign = 'right';
        textBlock.appendChild(longRatingTextElement);

        ratingBlock.appendChild(textBlock);
        return ratingBlock;
    }
}